export const TrendingUp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.3359 5.25L15.1488 7.06292L11.2855 10.9262L8.11881 7.75958L2.25256 13.6337L3.36881 14.75L8.11881 10L11.2855 13.1667L16.273 8.18708L18.0859 10L18.0859 5.25L13.3359 5.25Z"
        fill="#10B981"
      />
    </svg>
  );
};
